import React from "react"

const VideoReviewsConfig = () => (
  <div className="rounded-lg border border-gray-light bg-white shadow-sm">
    <div className="border-b border-gray-light p-6">
      <h5 className="flex items-center text-lg font-semibold text-gray-dark">
        <i className="icon-settings mr-2 text-xl text-teal" />
        Video Configuration
      </h5>
    </div>
    <div className="p-6">
      <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
        <div>
          <h6 className="mb-4 font-semibold text-gray-dark">Allowed Formats:</h6>
          <ul className="space-y-2">
            <li className="flex items-center">
              <i className="icon-done mr-3 text-green" />
              MP4 (video/mp4)
            </li>
            <li className="flex items-center">
              <i className="icon-done mr-3 text-green" />
              MOV (video/quicktime)
            </li>
            <li className="flex items-center">
              <i className="icon-done mr-3 text-green" />
              AVI (video/x-msvideo)
            </li>
            <li className="flex items-center">
              <i className="icon-done mr-3 text-green" />
              WebM (video/webm)
            </li>
          </ul>
        </div>
        <div>
          <h6 className="mb-4 font-semibold text-gray-dark">Limitations:</h6>
          <ul className="space-y-2">
            <li className="flex items-center">
              <i className="icon-info mr-3 text-blue" />
              Maximum size: 100 MB
            </li>
            <li className="flex items-center">
              <i className="icon-info mr-3 text-blue" />
              Automatic processing to 720p
            </li>
            <li className="flex items-center">
              <i className="icon-info mr-3 text-blue" />
              Output format: Optimized MP4
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
)

export default VideoReviewsConfig
